import { graphql } from '@/gql';
import type { GeneratePartnerLogoUploadPresignedUrlMutation, GeneratePartnerLogoUploadPresignedUrlMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export type GeneratePartnerLogoUploadPresignedUrlInput = GeneratePartnerLogoUploadPresignedUrlMutationVariables;

export type GeneratePartnerLogoUploadPresignedUrlOutput =
  GeneratePartnerLogoUploadPresignedUrlMutation['generatePartnerLogoUploadPresignedUrl'];

export const generatePartnerLogoUploadPresignedUrl = async ({
  partnerCodeName,
}: GeneratePartnerLogoUploadPresignedUrlInput): Promise<GeneratePartnerLogoUploadPresignedUrlOutput> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation GeneratePartnerLogoUploadPresignedUrl($partnerCodeName: String!) {
        generatePartnerLogoUploadPresignedUrl(partnerCodeName: $partnerCodeName) {
          url
          key
          accessUrl
        }
      }
    `),
    variables: {
      partnerCodeName,
    },
  });

  return response.data!.generatePartnerLogoUploadPresignedUrl;
};
